module.exports = __webpack_public_path__ + "img/business.84035db6.gif";